import { useQuery } from "@tanstack/react-query";
import { fetcher } from "../../utils/fetchers";
import {
  getAdminAccessToken,
  getStoreAccessToken,
  getStoreId,
} from "../../utils/auth";
import { Offer } from "../../types/modules/offer.type";

interface UseOffersParams {
  page?: number;
  limit?: number;
  name?: string;
  type?: string;
  storeId?: number;
}

export const useStoreOffers = ({
  page = 1,
  limit = 10,
  name = "",
  type = "",
  storeId,
}: UseOffersParams) => {
  const queryParams = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
    name: name?.toString(),
    type: type?.toString(),
  });

  if (storeId) {
    queryParams.append("storeId", storeId.toString());
  }

  const storeIdToSend = storeId ? storeId : getStoreId();
  const token = storeId ? getAdminAccessToken() : getStoreAccessToken();

  return useQuery({
    queryKey: ["store-offers", page, limit, name, storeIdToSend, type, token],
    queryFn: () =>
      fetcher<{ offers: Offer[]; totalItems: number; totalPages: number }>(
        `offer/byStore/all?${queryParams.toString()}`,
        token
      ),
  });
};
